import * as yup from 'yup';

export const AccountSchema = yup.object({
  owner: yup.string().required(),
  accountNr: yup.string().required(),
  iban: yup.string().required(),
  bic: yup.string().required(),
  bank: yup.string().required(),
  creditorId: yup.string().required(),
});

export interface IAccount {
  owner: string;
  accountNr: string;
  iban: string;
  bic: string;
  bank: string;
  creditorId: string;
}
